<template>
  <div>
    <h5 v-text="disbursementInformed ? 'Proposta': 'Simulação'"></h5>

    <div class="row" v-show="!novaSimulacao && disbursementInformed">

      <div class="col s12">
        <div class="card">
          <table class=" bordered">
            <tbody>
            <tr>
              <th class="td-tall">Produto</th>
              <td class="td-tall">{{form.produto_nome}}</td>
              <th class="td-tall">Data desembolso</th>
              <td class="td-tall">{{form.data_desembolso}}</td>
            </tr>
            <tr>
              <th class="td-tall">Número de parcelas</th>
              <td class="td-tall">{{form.numero_parcelas}}</td>
              <th class="td-tall">Dia pagamento</th>
              <td class="td-tall">{{form.dia_pagamento}}</td>
            </tr>
            <tr>
              <th class="td-tall">Total</th>
              <td class="td-tall">{{form.total | currency('R$', 2, ',', '.')}}</td>
              <td colspan="2">
                <button v-bind:disabled="fazendo_simulacao"
                        class="waves-effect waves-light btn btn-default"
                        @click="fazerNovaSimulacao()" v-if="!$hasRole('is_guest')">Alterar proposta
                </button>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="div" v-show="novaSimulacao">
      <label>(*)Campos obrigatórios.</label>
    </div>

    <div v-show="novaSimulacao || !disbursementInformed">
      <div class="row">
        <div class="col s12">
          <div class="switch">
            <p>Tipo de simulação <br></p>
            <label>
              KRÉDITS
              <input type="checkbox" v-model="form.acbs">
              <span class="lever"></span>
              ACBS
            </label>
          </div>
        </div>
      </div>
      <div class="row">
        <template v-show="!is_promotor">
          <div class="input-field col s6" v-if="produtos.length > 0">
            <material-select id="produto" v-model="produto">
              <option disabled selected hidden value=""></option>
              <option v-for="item in produtos" :value="JSON.stringify(item)">{{ exibirOption(item) }}
              </option>
            </material-select>
            <label for="produto">
              Produto
            </label>
          </div>
          <div class="col s6" v-else>
            Carregando produtos...
          </div>
        </template>

        <div class="col" :class="{ s4: is_promotor, s6: !is_promotor }">
          <mask-money id="total"
                      v-model="form.total"
                      :flag-disabled="refinanciamento == true"
                      :decimals="true"
                      label="Total"></mask-money>
        </div>
      </div>
      <div class="row">
        <div class="input-field col s4" v-show="!is_promotor">
          <input :disabled="is_promotor == true || refinanciamento == true" type="tel" class="input mask-date"
                 id="data_desembolso"
                 v-model.lazy="form.data_desembolso">
          <label for="data_desembolso">Data de desembolso</label>
        </div>

        <div class="input-field col s4" v-show="!is_promotor">
          <input :disabled="is_promotor == true" type="number" class="input" id="dia_pagamento"
                 v-model="form.dia_pagamento">
          <label for="dia_pagamento">Dia do pagamento</label>
        </div>

        <div class="input-field col s4">
          <input type="number" class="input" id="numero_parcelas" v-model="form.numero_parcelas">
          <label for="numero_parcelas">Número de parcelas</label>
        </div>
      </div>
      <div class="row" v-if="form.acbs== true">
        <div class="input-field col s6">
          <label for="fixed_day">
            <input
                    class="filled-in"
                    type="checkbox"
                    v-model="form.fixedDay"
                    id="fixed_day"
            />
            <span>Dias fixos (para comparação com Seek)</span>
          </label>
        </div>
        <div class="input-field col s6">
          <div>
            <span>IOF Financiado: </span> <b>{{productIofIsFinanced}}</b>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col s12 right-align">
          <button class="waves-effect waves-light btn" @click="gerarSimulacao">Gerar simulação</button>

          <button class="waves-effect waves-light btn" @click="alteraDesembolso" v-if="disbursementInformed">
            Salvar proposta
          </button>
        </div>
      </div>
    </div>

    <div class="row" v-if="fazendo_simulacao">
      <div class="col s12 center">
        <div class="preloader-wrapper small active">
          <div class="spinner-layer spinner-blue">
            <div class="circle-clipper left">
              <div class="circle"></div>
            </div>
            <div class="gap-patch">
              <div class="circle"></div>
            </div>
            <div class="circle-clipper right">
              <div class="circle"></div>
            </div>
          </div>

          <div class="spinner-layer spinner-red">
            <div class="circle-clipper left">
              <div class="circle"></div>
            </div>
            <div class="gap-patch">
              <div class="circle"></div>
            </div>
            <div class="circle-clipper right">
              <div class="circle"></div>
            </div>
          </div>

          <div class="spinner-layer spinner-yellow">
            <div class="circle-clipper left">
              <div class="circle"></div>
            </div>
            <div class="gap-patch">
              <div class="circle"></div>
            </div>
            <div class="circle-clipper right">
              <div class="circle"></div>
            </div>
          </div>

          <div class="spinner-layer spinner-green">
            <div class="circle-clipper left">
              <div class="circle"></div>
            </div>
            <div class="gap-patch">
              <div class="circle"></div>
            </div>
            <div class="circle-clipper right">
              <div class="circle"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <simulacao-parcelas-resultado-novo v-if="resultado_simulacao" :roles="this.roles"
                                       :resultado_simulacao="resultado_simulacao"
                                       :data_desembolso="form.data_desembolso"
                                       :loading="fazendo_simulacao"></simulacao-parcelas-resultado-novo>


    <div v-if="limiteValorProduto" class="row">
      <div class="card-panel orange lighten-2 white-text col s12 center ">
        <p><i class="material-icons left">warning</i>Valor não está em conformidade com o Produto selecionado
        </p>
      </div>
    </div>
  </div>
</template>

<script>
  import apiProducts from '../api/produtos.js'
  import apiDisbursements from '../api/disbursements.js'
  import SimulacaoParcelasResultadoNovo from './SimulacaoParcelasResultadoNovo'

  export default {
    components: {
      'SimulacaoParcelasResultadoNovo': SimulacaoParcelasResultadoNovo,
    },
    props: [
      'desembolso',
      'refinanciamento',
      'data_desembolso',
      'total_par',
      'dia_pagamento_par',
      'numero_parcelas_par',
      'status',
    ],
    data: function () {
      return {
        fazendo_simulacao: false,
        novaSimulacao: false,
        produto: '',
        form: {
          id: '',
          acbs: true,
          product_id: '',
          total: this.total_par,
          data_desembolso: this.data_desembolso || moment().format('DD/MM/YYYY'),
          dia_pagamento: this.dia_pagamento_par,
          numero_parcelas: this.numero_parcelas_par,
          produto_nome: '',
          fixedDay: false,
        },
        resultado_simulacao: {
          parcelas: [],
          total: '',
          saldoDevedor: '',
          total_emprestimo: '',
          total_liquido: '',
          total_juros: '',
          total_taxas: '',
          iof_financiado: '',
          total_iof_financiado: '',
          taxa_juros_formatada: '',
          taxa_cadastro_formatada: '',
          juros_mensal: '',
        },
        produtos: [],
        flagDesembolso: false,
        flagRefinanciamento: false,
      }
    },
    watch: {
      form: {
        handler: function (newValue) {
          this.parcelas = []
        },
        deep: true,
      },
      limiteValorProduto: function (newVal) {
        this.$emit('limite', newVal)
      },
      produto (value) {
        if (value == undefined) return

        let obj = JSON.parse(value)
        this.form.product_id = obj.id
        this.form.produto_nome = obj.nome

        this.resultado_simulacao.juros_mensal = obj.taxa // %
        this.resultado_simulacao.valor_minimo = obj.valor_min
        this.resultado_simulacao.valor_maximo = obj.valor_max

      },
      novaSimulacao: function (newVal) {
        this.$emit('nova-simulacao', newVal)
      },
    },
    updated () {
      if (typeof Materialize.updateTextFields != 'undefined')
        Materialize.updateTextFields()

      bus.$emit('updateFormCliente')
    },
    mounted () {
      if (this.desembolso !== undefined) {
        this.form = this.desembolso
        this.form.acbs = true
        this.form.financed_iof = true
      }

      apiProducts.getAll({}, false).then((r) => {
        this.loading = false
        this.produtos = r.data

        let selected = r.data.find(x => x.id === this.form.product_id)
        this.produto = JSON.stringify(selected)
      })

      if (this.is_promotor) {
        this.form.data_desembolso = moment().format('DD/MM/Y')
        this.form.dia_pagamento = moment().format('DD')
      }

      if (this.disbursementInformed) {
        this.gerarSimulacao()
      }
    },
    methods: {

      alteraDesembolso: function () {

        let that = this
        that.fazendo_simulacao = true
        //substituir pela apiDisbursements
        return axios.post('/ajax/alterar-desembolso/' + this.form.formulario_id, {
          simulacao: that.form,
          dados_emprestimo: that.resultado_simulacao,
        }).then(function (response) {
          that.fazendo_simulacao = false
          that.novaSimulacao = false
          that.gerarSimulacao()
        }).catch(({ response }) => {
          that.fazendo_simulacao = false

          if (typeof response != 'undefined' && response.status == 422) {
            bus.$emit('error-modal', response.data.errors)
          } else {
            bus.$emit('error-modal', { erros: ['Erro! Verifique sua conexão!'] })
          }
        })
      },
      fazerNovaSimulacao: function () {
        this.novaSimulacao = true
        this.resultado_simulacao = {
          id: '',
          parcelas: [],
        }
      },
      gerarSimulacao () {
        this.fazendo_simulacao = true

        let form = {
          id: this.form.id,
          acbs: this.form.acbs,
          product_id: this.form.product_id,
          requested_amount: this.form.total,
          contract_date: this.form.data_desembolso,
          payment_day: this.form.dia_pagamento,
          qty_installments: this.form.numero_parcelas,
          financed_iof: this.form.financed_iof,
          fixedDay: this.form.fixedDay,
        }

        this.loading = true

        form = JSON.parse(JSON.stringify(form))

        apiDisbursements.simulation({ simulation: form }).then((response) => {
          this.resultado_simulacao = response.data

          this.$emit('dados-emprestimo', this.resultado_simulacao) //mesmos dados?
          this.$emit('dados-simulacao', this.form)
          this.$emit('simulou-parcela')

          this.fazendo_simulacao = false

          this.$nextTick(() => window.scrollTo(0, window.pageYOffset + 300))

        }).catch((response) => {
          this.fazendo_simulacao = false
        })
      },
      dataFormatada (data) {
        return moment(data).format('DD/MM/Y')
      },
      exibirOption (produto) {
        if (this.is_promotor) {
          return (produto.taxa_juros_formatada) + '%'
        }
        return produto.nome + ' (' + (produto.taxa_juros_formatada) + '%)'
      },
    },
    computed: {
      productIofIsFinanced () {
        if (!this.form.product_id) {
          return ''
        }
        let selectedProduct = this.produtos.find(product => this.form.product_id == product.id)
        if (selectedProduct == undefined || selectedProduct.financedIof != 1) {
          return 'NÃO'
        }
        return 'SIM'
      },
      disbursementInformed () {
        return this.desembolso !== undefined && this.desembolso.id !== undefined
      },
      is_promotor () {
        return this.$hasRole('promotor')
      },
      limiteValorProduto: function () {
        if (this.resultado_simulacao.total_liquido) {
          return this.resultado_simulacao.total_liquido < this.resultado_simulacao.valor_minimo ||
            this.resultado_simulacao.total_liquido > this.resultado_simulacao.valor_maximo
        }
        return false
      },
    },
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/SimulacaoParcelasNovo.vue